__turbopack_context__.v({
  "animating": "styles-module__NAXNXa__animating",
  "filterSvg": "styles-module__NAXNXa__filterSvg",
  "glyph": "styles-module__NAXNXa__glyph",
  "glyphGrouped": "styles-module__NAXNXa__glyphGrouped",
  "lane": "styles-module__NAXNXa__lane",
  "number": "styles-module__NAXNXa__number",
  "separator": "styles-module__NAXNXa__separator",
  "sizer": "styles-module__NAXNXa__sizer",
});
